import React, { Component } from "react";
import styled from "styled-components";

interface CustomStatusBarProps {
  t: (text: string) => string;
}

interface CustomStatusBarState {
  rowCount: number | undefined;
}

const RowLabel = styled.span`
  color: ${(props) => props.theme.colors.grey50};
  font-weight: normal;
  margin-right: ${(props) => props.theme.sizes.xs};
`;

const RowCount = styled.span`
  color: ${(props) => props.theme.colors.grey90};
  font-weight: normal;
`;

const RowCountContainer = styled.div`
  display: flex;
  align-items: center;
  height: 42px;
  align-self: center;
`;

export default class GridStatusBarTotalRows extends Component<
  CustomStatusBarProps,
  CustomStatusBarState
> {
  state: CustomStatusBarState = {
    rowCount: undefined
  };

  setRowCount(rowCount: number | undefined): void {
    this.setState({ rowCount });
  }

  render(): React.ReactNode {
    return (
      <RowCountContainer>
        {this.state.rowCount != undefined ? (
          <>
            <RowLabel>{`${this.props.t("Total Rows")}:`}</RowLabel>
            <RowCount>{this.state.rowCount}</RowCount>
          </>
        ) : null}
      </RowCountContainer>
    );
  }
}
